import React, { memo } from 'react';
import { alarmSeverityToIconWithProductType, alarmSeverityToIcon, getKeyByValue } from 'common/utils/helpers';
import { isItBundle } from 'common/utils/deviceTwinUtils';
import { Alarms } from 'common/utils/constants';
import { alarmsColAccessor } from '../utils';

const DeviceTableAlarmCell = ({ device, productType, forAlarmMap }) => {
  const maxAlarm = alarmsColAccessor(device);
  const isBundle = isItBundle(device);

  let content = (
    <img
      id="DeviceTable_AlarmIcon"
      className="DeviceTable_AlarmIcon"
      alt={''}
      src={
        forAlarmMap
          ? alarmSeverityToIconWithProductType(maxAlarm, productType)
          : alarmSeverityToIcon(maxAlarm, isBundle ? true : false)
      }
      draggable="false"
    />
  );

  let title = getKeyByValue(Alarms, maxAlarm) || maxAlarm;

  return (
    <div id="DeviceTable_cellWrapper" className="DeviceTable_cellWrapper" data-tip={title}>
      <div id="DeviceTable_AlarmIconDiv" className="DeviceTable_AlarmIconDiv">
        {content}
      </div>
    </div>
  );
};

export default memo(DeviceTableAlarmCell);
